<template>
  <div id="unitManagement">
    <div class="commodity">
      <div class="pb20">
        <el-button size="small" type="primary" @click="dialogVisible = true"
          >新建单位</el-button
        >
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column
          align="left"
          prop="goodsUnitId"
          label="序号"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="goodsUnit"
          label="单位名称"
        ></el-table-column>
        <el-table-column align="center" prop="unitType" label="单位类型">
          <template slot-scope="scope">
            <div
              :style="{ color: scope.row.unitType == 1 ? '#409EFF' : '#000' }"
            >
              {{ scope.row.unitType == 1 ? "计数" : "计重" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="sourceType" label="单位来源">
          <template slot-scope="scope">
            <div
              :style="{ color: scope.row.sourceType == 2 ? '#409EFF' : '#000' }"
            >
              {{ scope.row.sourceType == 1 ? "系统预设" : "商家创建" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" class-name="tableHead" align="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.sourceType == 2"
              size="mini"
              @click="
                (goodsUnitId = scope.row.goodsUnitId), (dialogVisible2 = true)
              "
              type="primary"
              plain
              >删除</el-button
            >
            <el-button
              v-if="scope.row.isEnable == 1"
              size="mini"
              type="primary"
              @click="editUnit('U', scope.row.goodsUnitId, 0)"
              >禁用</el-button
            >
            <el-button
              v-if="scope.row.isEnable == 0"
              size="mini"
              type="primary"
              @click="editUnit('U', scope.row.goodsUnitId, 1)"
              plain
              >启用</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="block" style="float:right;margin-top:10px;">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="1"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="tableDataTotal.totalNum"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible2" width="30%">
      <span>是否删除该单位，删除后数据消失，无法恢复！！</span>
      <span slot="footer" class="dialog-footer" style="z-index:2100">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="editUnit('D', goodsUnitId)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="新建单位" :visible.sync="dialogVisible" width="30%">
      <div style="color:#999999">
        <div>
          单位类型：
          <span style="color:#000">计数</span>
        </div>
        <div>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;新增单位仅支持计数类型
        </div>
        <div class="row">
          <div class="center">单位名称：</div>
          <el-input
            style="margin:20px 0;width:300px;"
            v-model="goodsUnit"
            :maxlength="8"
            placeholder="最多8个字"
          ></el-input>
        </div>
        <div
          slot="footer"
          class="dialog-footer"
          style="z-index:2100;text-align: right;"
        >
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click.stop="saveUnit()"
            :disabled="disabled"
            >保 存</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  saveGoodsUnit,
  goodsUnitList,
  listTotalNum,
  batchUpdateUnit
} from "../api";
export default {
  data() {
    return {
      goodsUnit: "", //新增单位名称
      activeName: "third", //标签栏首选
      tableData: [],
      userList: [],
      tableDataTotal: [],
      shopInformation: [],
      goodsUnitId: "",
      dialogVisible: false, //增加单位提示框
      dialogVisible2: false, //删除单位提示框
      pageNum: 1,
      disabled: false
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
    this.PortGoodsUnitList();
  },
  methods: {
    //分页当前页
    handleCurrentChange(val) {
      this.pageNum = val;
      this.PortGoodsUnitList();
    },
    //更改单位状态
    editUnit(bachMethod, goodsUnitIds, isEnable) {
      batchUpdateUnit({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        bachMethod: bachMethod,
        goodsUnitIds: goodsUnitIds,
        isEnable: bachMethod == "U" ? isEnable : 1
      }).then(res => {
        if (res.code == 1) {
          this.$message({
            message: res.msg,
            type: "success"
          });
          this.PortGoodsUnitList();
          this.dialogVisible2 = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //创建单位
    saveUnit() {
      this.disabled = true;
      saveGoodsUnit({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        goodsUnit: this.goodsUnit
      }).then(res => {
        for (var i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].goodsUnit == this.goodsUnit) {
            this.$message({
              message: res.msg,
              type: "error"
            });
            return;
          }
        }
        if (res.code == 1) {
          this.disabled = false;
          this.$message({
            message: res.msg,
            type: "success"
          });
          this.PortGoodsUnitList();
          this.dialogVisible = false;
          this.$nextTick(() => {
            this.goodsUnit = "";
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //单位列表
    PortGoodsUnitList() {
      goodsUnitList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        pageNo: this.pageNum // 当前页码
        // row : pageSize // 每页记录数
      }).then(res => {
        if (res.code == 1) {
          this.tableData = res.data;
        } else {
          // this.$message.error(res.msg);
        }
      });
      listTotalNum({
        sessionId: this.userList.sessionId,
        userId: this.userList.id
      }).then(res => {
        if (res.code == 1) {
          this.tableDataTotal = res.data;
        } else {
          // this.$message.error(res.msg);
        }
      });
    }
  }
};
</script>

<style scoped>
.commodity {
  width: calc(100vw - 220px);
  position: absolute;
  top: 50px;
  padding: 25px;
  box-sizing: border-box;
}
.pb20 {
  padding-bottom: 20px;
  box-sizing: border-box;
}
::v-deep .el-table th {
  background-color: #f8f8f8;
}
</style>
<style>
/* .el-table th {
    background-color: #f2f2f2;
} */
</style>


// WEBPACK FOOTER //
// src/components/page/addUnitManagement.vue